module.exports = __webpack_public_path__ + "assets/img/teacher (50).5087861c.png";